const MENU = {
  AOI: 0,
  IMAGERY: 6,
  VECTORS: 1,
  // MODELS: 2,
  MAPS: 4,
  TASKS: 3, // Cam sua //
  // DATASETS: 6,
  // WORKFLOW: 7,
  HELP: 8,
  TABLE: 5,
  CATALOG: 2
}
export default MENU



// WEBPACK FOOTER //
// ./src/constants/menu-constants.js